import { render, staticRenderFns } from "./procedureRegisterForm.vue?vue&type=template&id=5ee8a029&"
import script from "./procedureRegisterForm.vue?vue&type=script&lang=js&"
export * from "./procedureRegisterForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports